import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PALETTE } from "../Theme/Palette";
import { ReactComponent as Logo } from "../assets/logo/Logo.svg";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import { IoChevronForwardCircleOutline } from "react-icons/io5";

function AboutUs() {
  const navigate = useNavigate();
  const screenWidth = window.innerWidth;
  const transformStyle = screenWidth >= 1400 ? "scale(4)" : "scale(3)";
  const topformStyle = screenWidth >= 1400 ? "40%" : "42%";

  return (
    <Grid bgcolor="#fff" minHeight="100vh" position="relative">
      <Logo
        style={{
          marginTop: "2rem",
          opacity: "0.1",
          position: "absolute",
          right: "45%",
          top: topformStyle,
          transform: transformStyle,
        }}
      />

      <Grid
        display="flex"
        sx={{ position: "absolute", right: "0", top: "1rem", zIndex: 2, cursor: "pointer" }}
        pr={1}
        pb={2}
        onClick={() => navigate("/sign-in")}
      >
        <Typography color={`${PALETTE.eightth}`}>بازگشت</Typography>
        <IoChevronForwardCircleOutline
          fontSize="1.6rem"
          color={`${PALETTE.eightth}`}
          style={{ marginLeft: "0.2rem" }}
        />
      </Grid>

      <Grid container display="flex" justifyContent="center" flexDirection="row">
        <Grid display="flex" justifyContent="flex-end">
          <Logo1 style={{ marginTop: "4rem", zIndex: 2, scale: "1.5" }} />
        </Grid>
        <Grid container pt={5} alignItems="center" justifyContent="center" flexDirection="column">
          <Typography
            boxSizing="border-box"
            width="65%"
            variant="h2"
            lineHeight="2rem"
            component="p"
            pr={1}
            style={{
              textAlign: "justify",
              background: "transparent",
              position: "relative",
              zIndex: 10,
            }}
          >
            <b style={{ fontWeight: "bold" }}>نام:</b> سامانه هوشمند همسان‌گزینی هدا (همسان‌گزینی
            دانشگاهی ایران)
            <br />
            <b style={{ fontWeight: "bold" }}>مالکیت:</b> مؤسسه فرهنگی همیاران زندگی پایدار هدا
            <br />
            <b style={{ fontWeight: "bold" }}>حوزه فعالیت:</b> ازدواج جوانان
            <br />
            <b style={{ fontWeight: "bold" }}>هدف:</b> همیاری و همراهی جوانان و متقاضیان ازدواج
            (دارای تحصیلات دانشگاهی) در راستای دستیابی به ازدواجی پایدار و آگاهانه با ایجاد بستری
            امن مبتنی بر استفاده از تکنولوژی و مشارکت خانواده.
            <br />
            <b style={{ fontWeight: "bold" }}>شرح فعالیت سامانه هدا:</b>
            <br />
            امروزه با توجه به بالا رفتن سن ازدواج و رشد جمعیت جوان مجرد کشور، لزوم کاربرد
            برنامه‌هائی فراتر و جامع‌تر از فعالیت‌های فردی جهت کمک به ازدواج جوانان و نیز استفاده از
            تکنولوژی مدرن کاملاً مشهود است. بر همین اساس مؤسسه هدا با تولید
            <b style={{ fontWeight: "bold" }}>"سامانه پیشرفته همسان‌گزینی هدا"</b> اقدام به تولید
            بستری هوشمند حاوی بانک اطلاعات گسترده‌ای از جوانان دارای تحصیلات دانشگاهی متقاضی و آماده
            ازدواج کرده است. کارشناسان متعهد و خبره مؤسسه نیز با استفاده از سامانه هوشمند هدا، همیار
            جوانان در انتخاب همسر همسان خود هستند.
            <br />
            با توجه به اینکه مؤسسه تحت مدیریت اساتید دانشگاه بوده و تمامی کارشناسان دارای تحصیلات
            عالیه هستند، همچنین متقاضیان نیز همگی جوانان تحصیل‌کرده می‌باشند، لذا همسان‌یابی در
            فضایی علمی و دانشگاهی صورت می‌گیرد. این فضای فرهنگی حاکم بر کارشناسان و متقاضیان
            می‌تواند منجر به انتخاب‌های کارشناسانه‌تر و مناسب‌تر گردد.
            <br />
            هم‌چنین متناسب با فضای دانشگاهی، جهت رعایت شرایط خانواده‌های اساتید دانشگاه‌ها و پزشکان
            محترم، مرکز جداگانه‌ای مختص این دسته از همکاران ایجاد شده است. اساتید و پزشکان گرامی و
            فرزندان آن‌ها می‌توانند در مرکز ویژه اساتید ثبت نام کنند.
            <br />
            <b style={{ fontWeight: "bold" }}>مراکز فعالیت سامانه هدا:</b>
            <br />
            سامانه هدا دارای یک مرکز مدیریت جامع می باشد که مسئولیت مدیریت تمام مراکز زیرمجموعه را
            بر عهده دارد.
            <br />
            هر یک از دانشگاه ها و نهادهای مرتبط با جوانان در صورت تمایل می‌توانند دارای یک مرکز
            اختصاصی باشند. این مراکز بر اساس استان و شهر محل زندگی متقاضی قابل جستجو می باشد.
            <br />
            مرکز اساتید، ویژه اساتید و پزشکان و فرزندان آن‌ها می باشد. (این مرکز شامل دانشجویان
            پزشکی عمومی نیست.)
            <br />
            <b style={{ fontWeight: "bold" }}>شیوه اجرائی:</b>
            <br />
            متقاضیان ازدواج باید با مراجعه به آدرس
            <a
              href="https://hoda.sbu.ac.ir"
              style={{
                padding: "0.4rem",
              }}
            >
              hoda.sbu.ac.ir
            </a>
            در سامانه ثبت نام و فرم‌های اطلاعاتی را به طور دقیق پر کنند. فرم‌ها توسط کارشناسان بررسی
            و در صورت تآیید نهایی، امکان جستجو در بانک به دو صورت برای متقاضی فراهم می‌شود:
            <br />
            <b style={{ fontWeight: "bold" }}>1)</b> جستجو توسط مرکز هدا
            <b style={{ fontWeight: "bold", paddingRight: "1.5rem" }}>2)</b> جستجو توسط متقاضی
            <br />
            نتایج جستجو به مرکز ارسال و پس از بررسی و انجام مراحل لازم توسط کارشناسان، در صورت مناسب
            بودن گزینه انتخابی، امکان ارتباط برقرار می‌گردد.
            <br />
            <b style={{ fontWeight: "bold" }}>مدیریت و کارشناسان:</b>
            <br />
            مدیرمؤسسه سرکار خانم دکتر قاسمی از اعضای هیئت علمی دانشگاه هستند.
            <br />
            کارشناسان مؤسسه همگی دارای تحصیلات عالیه دانشگاهی بوده و از بین اساتید و افراد متعهد و
            مجرب انتخاب شده‌اند.
            <br />
            <b style={{ fontWeight: "bold" }}>شرایط استفاده از خدمات سامانه هدا:</b>
            <br />
            کلیه افراد (مجرد، مطلقه، همسرفوت شده) از سراسر دنیا می‌توانند از خدمات سامانه هدا
            استفاده نمایند.
            <br />
            <b style={{ fontWeight: "bold" }}>شرایط زیر الزامی است:</b>
            <br />
            <b style={{ fontWeight: "bold" }}>1-</b> متقاضی حتماً باید دارای تحصیلات دانشگاهی باشد
            (مدرک دیپلم و کمتر از آن پذیرفته نیست). عزیزانی که تحصیلات دانشگاهی ندارند می‌توانند از
            خدمات مراکز فعال دیگر در حوزه ازدواج بهره‌گیری نمایند.
            <br />
            <b style={{ fontWeight: "bold" }}>2-</b> خدمات مؤسسه هدا صرفاً در جهت ازدواج دائم بوده و
            به هیچ وجه در حوزه ازدواج موقت و چند همسری فعالیت ندارد.
            <br />
            <b style={{ fontWeight: "bold" }}>آدرس مؤسسه:</b>
            <br />
            اوین- دانشگاه شهید بهشتی- دفتر مؤسسه هدا (همسان‌گزینی دانشگاهی ایران)
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AboutUs;
